export const environment = {
  production: true,
  apiUrl: 'https://api.wealthlane.webify.pro', // À modifier avec URL de production
  appName: 'WealthLane',
  appDescription: 'Votre plateforme de gestion de patrimoine',
  googleClientId: '228199346117-kd4n6s3csi0gf2lf9qp89j2cjto46ttv.apps.googleusercontent.com'
};
